/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Sla_Filter_On_TimeInputs */

const vi_order_sla_filter_on_time = /** @type {(inputs: Order_Sla_Filter_On_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn hạn`)
};

/**

* @param {Order_Sla_Filter_On_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_sla_filter_on_time = /** @type {((inputs?: Order_Sla_Filter_On_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Sla_Filter_On_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_sla_filter_on_time(inputs)
});